import { useState } from 'react'
import { Icon } from '@carrent/ui'

/**
 * Галерея добавления гаджетов.
 *
 * Показывает только те типы, что включены в каталоге: предлагать
 * то, чего человек не получит, хуже, чем не предлагать вовсе.
 */
export function WidgetGallery({ catalogItems, onAdd, onClose }) {
  const [query, setQuery] = useState('')

  const filtered = catalogItems.filter((item) => {
    if (!item.enabled) return false
    const q = query.trim().toLowerCase()
    if (!q) return true
    return (
      item.title.toLowerCase().includes(q) || item.description.toLowerCase().includes(q)
    )
  })

  const groups = filtered.reduce((acc, item) => {
    const key = item.category_label
    acc[key] = acc[key] || []
    acc[key].push(item)
    return acc
  }, {})

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label="Добавить гаджет">
      <div className="modal modal--wide">
        <header className="modal__head">
          <h2 className="modal__title">Добавить гаджет</h2>
          <button type="button" className="modal__close" onClick={onClose} aria-label="Закрыть">
            <Icon name="close" size={20} />
          </button>
        </header>

        <div className="modal__body">
          <input
            className="input"
            type="search"
            placeholder="Найти гаджет"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />

          {Object.keys(groups).length === 0 ? (
            <p className="widget-empty">Ничего не нашлось</p>
          ) : (
            Object.entries(groups).map(([group, items]) => (
              <div key={group} className="gallery__group">
                <span className="gallery__group-label">{group}</span>
                <div className="gallery__grid">
                  {items.map((item) => (
                    <button
                      key={item.type}
                      type="button"
                      className="gallery__card"
                      onClick={() => onAdd(item)}
                    >
                      <span className="gallery__card-title">{item.title}</span>
                      <span className="gallery__card-desc">{item.description}</span>
                      <span className="gallery__card-sizes">
                        {item.sizes.map((s) => s.toUpperCase()).join(' · ')}
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  )
}
